export default __webpack_public_path__ + "colored_language_attributes.png";